/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Billing_Addon_ChatInputs */

const en_billing_addon_chat = /** @type {(inputs: Billing_Addon_ChatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} chat messages`)
};

const id_billing_addon_chat = /** @type {(inputs: Billing_Addon_ChatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} pesan chat`)
};

/**
* | output |
* | --- |
* | "+{n} chat messages" |
*
* @param {Billing_Addon_ChatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addon_chat = /** @type {((inputs: Billing_Addon_ChatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addon_ChatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addon_chat(inputs)
	return en_billing_addon_chat(inputs)
});